// 订单的状态
export const orderStatusEnum = {
  unpayed: 0,
  canceled: 1,
  expired: 2,
  unshipped: 12,
  payFail: 13,
  deductionFail: 14,
  shipped: 21,
  finished: 22,
  waitReturnGoods: 23,
  unrefund: 30,
  refunding: 31,
  refunded: 32,
  unaudit: 41,
  auditing: 42,
  prescribeFail: 43,
  auditFail: 44,
  unprescribed: 45,
  prescribed: 46,
  refundReview: 47, // 退款审核
  waitGetGoods: 51,
  dealClose: 52
};

export const cargoStatus = {
  0: '待付款', // 可支付，可取消 *
  1: '已取消', // * h
  2: '已过期', // * h
  12: '待发货', // 可退款
  21: '待收货', // 确认收货
  22: '交易完成', // 可退款 h
  23: '待退货',
  30: '待退款',
  31: '退款中',
  32: '已退款', // h
  41: '审核中', // *
  42: '审核中', // (用户自己上传处方下单的状态)
  43: '审方失败',
  44: '审核失败', // (用户自己上传处方下单的状态)
  45: '待开方',
  46: '已开方',
  47: '退款审核',
  51: '待取货',
  52: '交易关闭',
  88: '交易关闭'
};

export const logStatsMap = {
  0: '待接单',
  1: '已接单',
  2: '已到店',
  3: '已获货',
  4: '已送达',
  5: '已取消',
  6: '退回途中',
  7: '退回签收',
  8: '已揽收',
  9: '配送中',
  10: '派件中',
  11: '拒签',
  12: '转单',
  13: '配送异常',
  14: '待揽收'
};

export const RefundStateEnum = {
  FAIL: 88,
  SUCCESS: 87,
  REFUNDING: 86,
  REFUND_AUDIT: 85,
  IN_RETURN_GOODS: 84,
  WAIT_RETURN_GOODS: 83,
  REVIEW: 81
};

export const refundProductStateCnMap = {
  [RefundStateEnum.FAIL]: '退款失败',
  [RefundStateEnum.SUCCESS]: '退款成功',
  [RefundStateEnum.HAS_RETURN_GOODS]: '退款申请中',
  [RefundStateEnum.REFUNDING]: '退款中',
  [RefundStateEnum.WAIT_RETURN_GOODS]: '退款申请中'
};

export const codFlagEnum = {
  payOnline: 0,
  payOffLine: 1 // 货到付款
};

export const refundStatusZhEnum = {
  81: '审核中', // 天宇说 ： 运营审核或供应商审核
  83: '待退货', //
  84: '退货中', // 待供应商确认收货
  85: '退款审核', // 待财务审核
  86: '退款中',
  87: '已退款',
  88: '退款已关闭'
};

// 类型
export const invoiceTypeZhMap = {
  1: '个人',
  2: '公司'
};

// 方式
export const invoiceWayZhMap = {
  1: '纸质发票',
  2: '电子发票'
};
export const ResourceCodeEnum = {
  DefaultSearchPlaceholder: 'ZYYDSC001',
  HotKeywordList: 'ZYYDSC002',
  RecommendWordList: 'ZYYDSC003',
  ChannelList: 'ZYYDSC004',
  TipsList: 'ZYYDSC005',
  BannerList: 'ZYYDSC006',
  TabList: 'ZYYDSC007'
};

export const RxTypeNum = {
  CHUFANGYA0: 1,
  OTC: 2
};
